//*** 公用常量 ***

//1.电话号码格式验证正则表达式**
const telreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
//2.身份证号码格式验证正则表达式**
const cardreg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
//3.邮箱格式验证正则表达式**
const emailreg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
//4.限中文 **
const testExpress = /[^\u4E00-\u9FA5]/g;
//5.去除html标签
const htmlReg = /<\/?[^>]*>/g;
const title = '慧航升本系统'
// 调用token接口时必传参数
const grant_type = 'refresh_token';
const client_id = 'huihang-admin';
const client_secret = 'zsb.web.secret';
const ProjectId = 3; //项目Id
//签到类型
const signInCategoryList = [{
    key: 1,
    value: '上课签到'
}, {
    key: 2,
    value: '下课签到'
}]
//签到方式
const signInWayList = [{
    key: 1,
    value: '地图签到'
}, {
    key: 2,
    value: '手动签到'
}, {
    key: 3,
    value: '直播间签到'
}, {
    key: 4,
    value: '教务帮签'
}]
//请假类型
const leaveCategoryList = [{
    key: 1,
    value: '事假'
}, {
    key: 2,
    value: '病假'
}]
//审批状态
const approvalStateList = [{
    key: 1,
    value: '待审批'
}, {
    key: 2,
    value: '审批通过'
}, {
    key: 3,
    value: '审批拒绝'
}]
//订单类型
const orderTypeList = [{
    key: 1,
    value: '普通订单'
}, {
    key: 2,
    value: '分期订单'
}, {
    key: 3,
    value: '开团订单'
}, {
    key: 4,
    value: '参团订单'
}, {
    key: 5,
    value: '积分订单'
}, {
    key: 6,
    value: '免费订单'
}, 
]
//订单状态
const orderStateList = [{
    key: 1,
    value: '待支付'
}, {
    key: 2,
    value: '拼团中'
}, {
    key: 3,
    value: '部分付款'
}, {
    key: 4,
    value: '订单完成'
}, {
    key: 5,
    value: '订单部分退费'
}, {
    key: 6,
    value: '订单全退费'
}, {
    key: 7,
    value: '交易关闭'
},{
    key: 8,
    value: '已转课(转出)'
},
]
//变更类型
const orderMoneyChangeTypeList = [{
    key: 1,
    value: '退费'
}, {
    key: 2,
    value: '减免'
}]
// 判断当前页面前缀是http还是https
const ishttps = document.location.protocol;
// 前台域名\前台电脑端域名 已经修改为存储allConfig中，使用this.$store.state.allConfig || JSON.parse(sessionStorage.getItem('allConfig'))拿取
const isAdminPubilcList = [{
    key: 0,
    value: '全部'
},
{
    key: 1,
    value: '公用操作(不需要授权)'
},
{
    key: 2,
    value: '非公用操作(限授权角色使用)'
},
]
// signalR客户端连接地址
// const signalRDomainStu = "http://47.98.186.79:7567"; //测试环境-学员
const signalRDomain = "http://w.uzxue.cn/TZsbAdminSignrApi"; //测试环境-管理员

// 正则提取字符串中的所有url
const getUrlList = /(https?|http|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g;
//此默认色必须和后台设置的主题合并一起才可以更换全局主题(接口返回的那几个自定义的不给力，加四个默认色才生效)
const defaultColor = {
    Success: "#67C23A",
    Warning: "#E6A23C",
    Danger: "#F56C6C",
    Info: "#909399",
}
//没有设置主题色的人员登录用这个默认主题
const defaultThemeStyle = {
    ThemeColor: '#409EFF', //主题色
    SliderMenuColor: '#eef1f6', //菜单背景色
    MenuFontColor: '#333333', //菜单字体色
    UnderlineColor: '#eef1f6', //菜单下划线色 动态计算 菜单背景色的浅色
    HeadBgColor: '#409EFF', //头部背景色
    HeadTextColor: '#FFFFFF', //头部字体色
    Success: "#67C23A",
    Warning: "#E6A23C",
    Danger: "#F56C6C",
    Info: "#909399",
}
// const signalRDomain = ishttps == 'http:'?"http://w.huihangedu.cn":"https://w.huihangedu.cn";//生产环境
export {
    telreg,
    cardreg,
    testExpress,
    emailreg,
    htmlReg,
    grant_type,
    client_id,
    client_secret,
    signInCategoryList,
    signInWayList,
    leaveCategoryList,
    approvalStateList,
    orderTypeList,
    orderMoneyChangeTypeList,
    orderStateList,
    signalRDomain,
    title,
    isAdminPubilcList,
    getUrlList,
    defaultColor,
    defaultThemeStyle,
    ProjectId
}